<template>
  <el-checkbox-group v-model="val">
    <template v-for="(item,idx) in list">
      <el-checkbox :label="item.value" :key="idx" v-if="!item.id">{{ item.label }}</el-checkbox>
      <el-checkbox :label="item.value" :key="idx" v-if="item.id">
        {{ item.pre }}{{ item.label }}<input
          type="text" :style="{width:item.width}" @input="inputChange(idx)" v-model="inputVal[idx]">{{ item.suf }}
      </el-checkbox>
    </template>
  </el-checkbox-group>
</template>

<script>
export default {
  name: "staff-checkbox-group",
  props: {
    id: String,
    handler: String,
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      val: [],
      inputVal: []
    }
  },
  computed: {
    list() {
      return this.data.map((r, i) => {
        if (typeof r === 'string') {
          return {
            value: i,
            label: r
          }
        }
        return {
          ...r
        }
      });
    }
  },
  watch: {
    value(newV) {
      Log('checkboxChange-value', [...newV], [...this.val])
      if (!this.equal([...newV], [...this.val]))
        this.val = newV.map(r => parseInt(r));
      else Log('checkboxChange value值未发生变化')
    },
    val(newV) {
      Log('checkboxChange-val', [...newV], [...this.value])
      if (this.equal([...newV], [...this.value])) {
        Log('checkbox val nocheng')
      } else {
        this.$emit('input', newV);
      }
    },
    inputVal(newV) {
      let obj = {};
      newV.forEach((r, i) => {
        let extra = this.list[i];
        obj[extra.id] = r;
      });
      this.$emit('inputChange', obj);
    }
  },
  created() {
    this.val = this.value;
    this.initInputVal();
  },
  methods: {
    inputChange(index) {
      let val = this.inputVal[index];
      let meta = this.list[index];
      if (val) {
        val = parseInt(val);
        if (typeof meta.max === 'number') {
          if (val > meta.max) {
            this.$message.error('最大值不能超过' + meta.max);
            this.inputVal.splice(index, 1, meta.max);
          }
        }
        if (typeof meta.min === 'number') {
          if (val < meta.min) {
            this.$message.error('最小值不能低于' + meta.min);
            this.inputVal.splice(index, 1, meta.min);
          }
        }
      }
    },
    equal(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      for (let i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) < 0) return false;
      }
      return true;
    },
    initInputVal() {
      if (this.data)
        this.data.forEach((rr, i) => {
          this.inputVal.splice(i, 1, rr.data || '');
        })
    }
  }
  ,
}
</script>

<style scoped lang="scss">
input {
  border: 0px none;
  width: 60px;
  border-bottom: 1px #cccccc solid;
  padding: 0px 5px;
  outline: none;
}
</style>